module.exports = __webpack_public_path__ + "static/images/card-bg-1.86e78d3.png";